import { render, staticRenderFns } from "./DatosCita.vue?vue&type=template&id=45190e60&"
import script from "./DatosCita.vue?vue&type=script&lang=js&"
export * from "./DatosCita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports